<h2 mat-dialog-title>{{ isSender ? 'Sender' : 'Beneficiary' }} Report</h2>
<mat-dialog-content>
  <form class="mat-form" [formGroup]="filterForm">
    <div class="row">
      <div class="col-md-6 form-group">
        <app-input-datepicker
          [inputData]="field['fromDate']"
          [formControlName]="'from_date'"></app-input-datepicker>
      </div>
      <div class="col-md-6 form-group">
        <app-input-datepicker
          [inputData]="field['toDate']"
          [formControlName]="'to_date'"></app-input-datepicker>
      </div>
      <div class="col-md-6 form-group" *ngIf="!isSender">
        <app-input-select
          [inputData]="field['amountType']"
          [selectOptions]="amountTypes"
          [bindLabel]="'name'"
          [bindValue]="'value'"
          [formControlName]="'amount_type'"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-template
          [inputData]="field['cumulativeAmount']"
          [formControlName]="'cumulative_amount'"></app-input-template>
      </div>
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="field['cumulativeAmountOp']"
          [selectOptions]="amountOperators"
          [bindLabel]="'name'"
          [bindValue]="'value'"
          [formControlName]="'cumulative_amount_op'"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="field['sourceCountry']"
          [selectOptions]="countryList"
          [bindLabel]="'country_name'"
          [bindValue]="'alpha3'"
          [formControlName]="'source_country'"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="field['destinationCountry']"
          [selectOptions]="countryList"
          [bindLabel]="'country_name'"
          [bindValue]="'alpha3'"
          [formControlName]="'destination_country'"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="field['transferType']"
          [selectOptions]="transferTypes"
          [bindLabel]="'name'"
          [bindValue]="'value'"
          [formControlName]="'transfer_type'"></app-input-select>
      </div>
      <ng-container *ngIf="isSender">
        <div class="col-md-6 form-group">
          <app-input-select
            [inputData]="field['countryOfBirth']"
            [selectOptions]="countryList"
            [bindLabel]="'country_name'"
            [bindValue]="'alpha3'"
            [formControlName]="'country_of_birth'"></app-input-select>
        </div>
        <div class="col-md-6 form-group">
          <app-input-template
            [inputData]="field['beneficiaryId']"
            [formControlName]="'beneficiary_id'"></app-input-template>
        </div>
      </ng-container>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    type="button"
    class="btn ghost-btn"
    (click)="cancel()"
    [disabled]="loading">
    Cancel
  </button>
  <button
    type="button"
    class="btn primary-btn"
    (click)="generate()"
    [disabled]="loading">
    {{ loading ? 'Generating...' : 'Generate & Export' }}
  </button>
</mat-dialog-actions>
